export class LoadSigneesAction {
  static readonly type = '[Signee] LoadSigneesAction';
}

export class ClearSigneeList {
  static readonly type = '[Signee] ClearSigneeList';
}
